import { render, staticRenderFns } from "./setting-wht.vue?vue&type=template&id=20689d5c"
import script from "./setting-wht.vue?vue&type=script&lang=js"
export * from "./setting-wht.vue?vue&type=script&lang=js"
import style0 from "./setting-wht.vue?vue&type=style&index=0&id=20689d5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports